import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StructureArrow } from '../../../../MyTeamBackofficeStyled';
import { getRootTeamMember } from '../../../../myTeamBackOffice.actions';
import { Icon, IconStructureNavArrow } from '../../../../../../styles/Icons';
import { color } from '../../../../../../styles/GlobalStyles';
import { StructureType } from '../../../../myTeamBackOffice.constants';

export const GoLeftDownArrowButton = () => {
  const dispatch = useDispatch();
  const { rootTeamMember } = useSelector((store) => store.myTeamBackoffice);

  const isLeftArrowDownEnabled = rootTeamMember?.leftChildUser?.id;

  const goLeftDown = () => {
    if (isLeftArrowDownEnabled) {
      dispatch(
        getRootTeamMember(rootTeamMember.leftChildUser.id, StructureType.TEAM)
      );
    }
  };

  return (
    <StructureArrow
      reverse
      disabled={!isLeftArrowDownEnabled}
      onClick={goLeftDown}>
      <Icon color={color.colors.primary900}>
        <IconStructureNavArrow />
      </Icon>
    </StructureArrow>
  );
};
